import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import AccessoriesPageComponent from './AccessoriesPageComponent';

import accessoriesActions from './actions/AccessoriesActions';
import { toggleDOMClass } from '../core/actions/dom/DOMActions';
import { dismissSideNavAnnouncement } from '../core/actions/side-nav/SideNavActions';

const mapStateToProps = ({ config, accessories }) => ({
  config,
  accessories,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...accessoriesActions, toggleDOMClass, dismissSideNavAnnouncement }, dispatch),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AccessoriesPageComponent);
